<div class="container-fluid pt-3">
  <div class="jumbotron bg-transparent pb-1">
    <div class="score-box">
      <div class="score-box__text">
        Click <a href="https://portal.stratus.ms/sc-monitoring" target="_blank">here</a> and navigate to scorecard section to access all the scorecards.
      </div>
      <ul>
        <li class="score-box__text_li">
          All the scorecards have been migrated to Stratus to enhance the UI Experience.
        </li>
        <li class="score-box__text_li">
          If you do not have access to stratus score card - Request access to this SG to access scorecard page on stratus - <a href="https://idweb.microsoft.com/IdentityManagement/aspx/common/GlobalSearchResult.aspx?searchtype=e0c132db-08d8-4258-8bce-561687a8a51e&content=M360ScoreCardReaders&popupFromClipboard=%2Fidentitymanagement%2Faspx%2FGroups%2FEditGroup.aspx%3Fid%3D291fe9e6-e016-4a08-8f58-3cfb56f662df" target="_blank">
            M360ScoreCardReaders
          </a>, <a href="https://idweb.microsoft.com/IdentityManagement/aspx/common/GlobalSearchResult.aspx?searchtype=e0c132db-08d8-4258-8bce-561687a8a51e&content=M360ScoreCardWriters&popupFromClipboard=%2Fidentitymanagement%2Faspx%2FGroups%2FEditGroup.aspx%3Fid%3Dad303a05-aff7-4269-9563-77dd47f280f6" target="_blank">
            M360ScoreCardWriters
          </a>.
        </li>
        <li class="score-box__text_li">
          If you have any queries, please reach out to the support team at 
          <a href="mailto:M360PlatAdmin@microsoft.com">M360PlatAdmin&#64;microsoft.com</a>
        </li>
      </ul>
    </div>
    <!-- <h1 class="display-5" #titleDiv tabindex="-1">All Score cards have been migrated to Stratus to enhance the UI Experience.</h1> -->
    <hr class="my-4" />
    <p class="lead">
      The Scenario Health Score Card helps the organization track the weekly
      health score for the critical scenarios. The dashboard provides a way for
      process owners to input the health status for their respective areas which
      the platform uses to compute metrics for the assigned period.
    </p>
    <p class="lead">
      For Onboarding & Access, please visit:
      <a class="link-text" href="https://aka.ms/m360wiki" target="_blank">
        https://aka.ms/m360wiki
        <span class="fa fa-link" aria-hidden="true"></span>
      </a>
    </p>
    <p class="lead">
      Power BI Report for Critical Scenarios Health Trend can be accessed here:
      <a class="link-text" href="{{ reportUrl }}" target="_blank" rel="noreferrer noopener">
        Scenario Health Trend Report
        <span class="fa fa-link" aria-hidden="true"></span>
      </a>
    </p>
  </div>
</div>
<app-power-bi-input [reportInput]="powerBIConfig"></app-power-bi-input>
